import React from "react";
// import { EdgeeDataLayer, EdgeeDataLayerObject } from "react-edgee";
import { getSchema, BlogArguments } from "../data/base-schema";

type Translation = {
  url: string;
  locale: string;
};

type SEOProps = {
  title: string;
  description: string;
  pathname: string;
  socialImage?: string;
  noFollow?: boolean;
  locale?: string;
  translations?: Translation[];
  blog?: BlogArguments;
};

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  socialImage,
  noFollow,
  pathname,
  locale,
  translations,
  blog,
}) => {
  const siteMetaData = {
    title: `Upsun.com`,
    siteUrl: `https://upsun.com`,
    description: `description goes here`,
    twitterUsername: `upsuncom`,
  };

  const seo = {
    title: title || siteMetaData.title,
    description: description || siteMetaData.description,
    image: socialImage
      ? `${siteMetaData.siteUrl}${socialImage}`
      : `${siteMetaData.siteUrl}/default_social.png`,
    url: `${siteMetaData.siteUrl}${pathname || ``}`,
    twitterUsername: siteMetaData.twitterUsername,
  };

  // const edgeeDataLayer: EdgeeDataLayerObject = {
  //   data_collection: {
  //     events: [
  //       {
  //         type: "page",
  //         data: {
  //           name: seo.title,
  //           title: seo.title,
  //           url: seo.url,
  //           path: pathname,
  //           search: "",
  //         },
  //         components: {
  //           google_analytics: true,
  //         },
  //       },
  //     ],
  //     components: {
  //       google_analytics: true,
  //     },
  //   },
  // };

  const currentLocale = locale || "en";

  const customSchema = getSchema(pathname, title, description, blog);
  const customSchemaString = JSON.stringify(customSchema);

  return (
    <>
      <html lang={currentLocale} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta
        name="google-site-verification"
        content="UDRzjjNd_0mjepERCgT-Kr8VJrGHE1e2wWygFVRl34w"
      />
      <link rel="preconnect" href="https://cdn.cookielaw.org" />
      <link rel="preconnect" href="https://lp.platform.sh" crossOrigin={""} />
      {noFollow && <meta name="robots" content="noindex, nofollow" />}
      <script type="application/ld+json" key="schema">
        {customSchemaString}
      </script>
      {translations &&
        translations?.map((translation, index) => (
          <link
            rel="alternate"
            hrefLang={translation?.locale}
            href={`https://upsun.com${translation?.url}`}
            key={`alternate-${index}`}
          />
        ))
      }
      {/* <EdgeeDataLayer data={edgeeDataLayer} /> */}
    </>
  );
};
